import http from "./http.js";

async function getProductCategory(id) {
  try {
    const response = await http.get(`product-categories/${id}`);
    return {
      title: response.data.title,
      percent: response.data.percent,
    };
  } catch (err) {
    throw err;
  }
}

async function updateProductCategory(id, productCategory) {
  try {
    const response = await http.put(`product-categories/${id}`, productCategory);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createProductCategory(productCategory) {
  try {
    const response = await http.post("product-categories", productCategory);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProductCategories(
    page = 1,
    pageSize = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get("product-categories", {
      params: {
        page,
        pageSize,
        searchTerm: `${search}${filter}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getProducts(id) {
  try {
    const response = await http.get(`product-categories/${id}/products`);
    return response.data.map(i => {
      return {
        id: i.id,
        title: i.title,
        article: i.article,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function selectProductCategory(
    page = 1,
    pageSize = 9,
    search = ""
) {
  try {
    const response = await http.get("product-categories/references", {
      params: {
        page,
        pageSize,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getProductCategory,
  updateProductCategory,
  createProductCategory,
  getProductCategories,
  selectProductCategory,
  getProducts,
};
